export default __webpack_public_path__ + "img/fTLyNFrv.4be9974c.svg";